import PostsList from 'components/post/PostsList';
import { usePosts } from 'hooks/posts';

export default function Dashboard(props) {
  const { posts, isLoading: postsLoading } = usePosts({});
  return <>{!postsLoading ? <PostsList posts={posts} /> : ''}</>;
}
